import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { USER_READ, hasPrivilege } from 'utils/privileges';
import Stack from 'components/Stack';
import SparkPanel from 'components/SparkPanel';
import { PlaylistRecentUsersStats, PopularAssetInFolderOrPlaylistStats } from 'components/InlineStatsPanel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PlaylistAnalyticsPage(_ref) {
  var playlistId = _ref.playlistId,
    name = _ref.name;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "m",
    children: [/*#__PURE__*/_jsx(SparkPanel, {
      id: playlistId,
      type: "playlist",
      title: t('panel_playlist_stats_title')
    }), hasPrivilege(USER_READ) && /*#__PURE__*/_jsx(PlaylistRecentUsersStats, {
      id: playlistId,
      name: name
    }), /*#__PURE__*/_jsx(PopularAssetInFolderOrPlaylistStats, {
      playlistId: playlistId,
      title: t('analytics_popular_asset_plural'),
      name: name
    })]
  });
}
export default PlaylistAnalyticsPage;